import _ from "lodash";
import axios from "axios";

import IMeta from "models/IMeta";
import { setLoading } from "../app/actions";
import generateQuery from "helpers/query";
import { getOptions } from "helpers/common";
import { CUSTOM_SETTINGS } from "constants/.";

export const actionTypes = {
  GET_QUALITY_REPORTS_REQUEST: "GET_QUALITY_REPORTS_REQUEST",
  GET_QUALITY_REPORTS_SUCCESS: "GET_QUALITY_REPORTS_SUCCESS",
  GET_QUALITY_REPORTS_FAILURE: "GET_QUALITY_REPORTS_FAILURE",
  GET_QUALITY_SELECT_OPTIONS_REQUEST: "GET_QUALITY_SELECT_OPTIONS_REQUEST",
  GET_QUALITY_SELECT_OPTIONS_SUCCESS: "GET_QUALITY_SELECT_OPTIONS_SUCCESS"
};

export default class Actions {
  public static getQualityReports(meta: IMeta = {}) {
    return async (dispatch, getState) => {
      dispatch(request());
      dispatch(setLoading(true));

      if (_.isEmpty(meta)) {
        meta = _.get(getState(), "qualityReports.meta", {});
      }

      if (!meta.pageSize) {
        const savedSettings = JSON.parse(
          localStorage.getItem("customSettings") || "{}"
        );
        _.set(
          meta,
          "pageSize",
          _.get(savedSettings, `${CUSTOM_SETTINGS.qualityReport}.pageSize`, 10)
        );
      }

      const url = `InspectionReports?$select=Id,DocumentId,Number,BatchNumber,ItemDescription,Size,Date,TypeId,Read,
        ArrivalDate,SupplierName,OrderNumber${generateQuery(
          meta,
          "RelationId"
        )}`;

      try {
        const { data } = await axios.get(url);
        const payload = _.get(data, "value", []);
        const newMeta = {
          ...meta,
          count: +_.get(data, "odata.count", 0)
        };
        dispatch(success(payload, newMeta));
        dispatch(setLoading(false));
      } catch (error) {
        dispatch(failure(error));
        dispatch(setLoading(false));
      }
    };

    function request() {
      return { type: actionTypes.GET_QUALITY_REPORTS_REQUEST };
    }
    function success(payload, meta) {
      return { type: actionTypes.GET_QUALITY_REPORTS_SUCCESS, payload, meta };
    }
    function failure(error) {
      return { type: actionTypes.GET_QUALITY_REPORTS_FAILURE, error };
    }
  }

  public static getSelectOptions() {
    return async dispatch => {
      dispatch(request());

      try {
        const { data } = await axios.get("InspectionReports/Enums");
        const typeOptions = getOptions(data, "InspectionReportType");
        dispatch(success(typeOptions));
      } catch (error) {
        dispatch(failure(error));
      }
    };

    function request() {
      return { type: actionTypes.GET_QUALITY_SELECT_OPTIONS_REQUEST };
    }
    function success(payload) {
      return { type: actionTypes.GET_QUALITY_SELECT_OPTIONS_SUCCESS, payload };
    }
    function failure(error) {
      return { type: actionTypes.GET_QUALITY_REPORTS_FAILURE, error };
    }
  }
}
